<template>
  <div id="user-search">
    <div class="content">
      <input
        type="text"
        class="search"
        v-model="search"
        :placeholder="placeholder"
        @keydown="switchIndex"
        ref="search"
      />
      <div class="results">
        <div
          v-for="(result, index) in allResults"
          class="result"
          :class="{ selected: isSelected(index) }"
          :key="result.id"
          @click="userClick(result)"
        >
          {{ result.phone }}
          <span v-if="result.name">
            {{ getFullname(result) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VLD from '@/utils/validate'
import { API } from '@/config'
import { getFullname } from '@/utils/name'

export default {
  name: 'UserSearch',
  props: {
    placeholder: {
      type: String,
      default: 'Имя, фамилия или телефон'
    },
    select: {
      type: String,
      default: undefined
    },
    onlyPhone: {
      type: Boolean,
      default: false
    },
    addButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searching: false,
      search: '',
      results: [],
      resultIndex: 0
    }
  },
  computed: {
    allResults () {
      if (!this.addButton) return this.results
      if (this.search.length)
        return [...this.results, { id: 'new', phone: 'Создать' }]
    }
  },
  watch: {
    search (nv) {
      if (nv.length > 2) this.trySearch(nv)
      else this.results = []
    }
  },
  methods: {
    isSelected (index) {
      return this.resultIndex === index
    },
    switchIndex (e) {
      if (e.keyCode === 13) {
        if (!this.allResults.length) return
        this.userClick(this.allResults[this.resultIndex])
        return
      }

      if (e.keyCode !== 38 && e.keyCode !== 40) return
      if (this.allResults.length < 1) return
      if (e.keyCode === 38) {
        if (this.resultIndex === 0)
          return (this.resultIndex = this.allResults.length - 1)
        this.resultIndex -= 1
      } else if (e.keyCode === 40) {
        if (this.resultIndex === this.allResults.length - 1)
          return (this.resultIndex = 0)
        this.resultIndex += 1
      }
    },
    formatResult (res) {
      if (!res) return
      let name = res.name
      return `${name} ${res.phone}`
    },
    async trySearch (search) {
      if (this.searching) return
      if (this.onlyPhone && !/\+?[0-9]+/.test(search)) return

      this.searching = true

      let payload = {
        search: search,
        onlyPhone: this.onlyPhone,
        select: this.select
      }

      let { data } = await this.$http.post(API.USERS.search, payload)
      this.searching = false
      if (!data || data.err) return this.$notify(data ? data.err : '')

      this.results = data

      this.resultIndex = 0
      this.searching = false
    },
    async userClick (user) {
      if (user.id === 'new') return this.$emit('create')

      let { data } = await this.$http.get(API.USERS.chat + user.id)
      if (!data || data.err) return this.$notify(data.err)
      this.$emit('selected', { ...user, chat: data.id })

      this.search = ''
      this.results = []
    },
    getFullname
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

#user-search {
  width: 100%;
  display: flex;
  justify-content: center;
}

.content {
  width: 60%;
  max-width: 400px;
  height: auto;
  position: relative;
}

.search {
  width: 100%;
  padding: 15px;
  text-align: center;
  font-size: 16px;
  line-height: 14px;
  border: none;
  border-radius: 12px;
  box-sizing: border-box;
  outline: none;
  background: @grey;
}

.results {
  width: 100%;
  margin-top: 10px;
  background: #fff;
  border-radius: 10px;
  position: absolute;
  z-index: 2;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);

  .result {
    padding: 10px 15px;
    border-radius: 10px;
    cursor: pointer;

    &.notvalid {
      text-decoration: line-through;
    }

    &.selected,
    &:hover {
      background: @accent;
      color: #fff;
    }

    &.selected:hover {
      background: darken(@accent, 5%);
    }

    span {
      // opacity: 0.5;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>
